import { isRadii, isShadow, isColor } from '../../../../theme';
export const withBorders = ({ theme, ...props }) => {
    const rules = {};
    if (props.borderRadius) {
        rules.borderRadius = isRadii(props.borderRadius) ? theme.radii[props.borderRadius] : props.borderRadius;
    }
    if (props.boxShadow) {
        rules.boxShadow = isShadow(props.boxShadow) ? theme.shadows[props.boxShadow] : props.boxShadow;
    }
    rules.borderRight = props.borderRight;
    rules.borderLeft = props.borderLeft;
    rules.borderTop = props.borderTop;
    rules.borderBottom = props.borderBottom;
    if (props.borderColor) {
        rules.borderColor = isColor(props.borderColor) ? theme.colors[props.borderColor] : props.borderColor;
    }
    if (props.border) {
        rules.border = props.border;
    }
    return rules;
};
